import { render, staticRenderFns } from "./yhf.vue?vue&type=template&id=5df23875&scoped=true&"
import script from "./yhf.vue?vue&type=script&lang=js&"
export * from "./yhf.vue?vue&type=script&lang=js&"
import style0 from "./yhf.vue?vue&type=style&index=0&id=5df23875&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df23875",
  null
  
)

export default component.exports